/* eslint-disable no-unused-vars */
import HttpService from '@/utils/httpService';
import store from '..';
import { ForgeInspection } from '@/scripts/js/forgeModels';
import { log as debugLog, error as debugError } from '@/utils/debugLogger';
import { FACILITY_REQUEST } from '@/utils/http/RequestRegistry';

export const InspectionDashboard = {
    state: {
        dispatchResetDashboardGrid: null,
        dispatchResetDashboardChart: null,
        showInspectionDashboard: false,
        showColumnChooserPopup: false,
        showFloatingPanel: false,
        inspectionCodesOptions: [],
        tempUnit: '°C',
        pressUnit: 'kg/cm²',
        tempPressFilter: [
            {
                name: 'Temperature',
                isChecked: false,
            }, {
                name: 'Pressure',
                isChecked: false,
            }, {
                name: 'None',
                isChecked: true,
            }
        ],
        InspectionTemperatureOptions: [
            {
                "code": 7,
                "codeOrdr": 1,
                "judgCrr1": 100,
                "judgMkr1": "≤",
                "judgCrr2": '-∞',
                "judgMkr2": ">",
                "judgSymb": "°C",
                "count": 0,
                "isChecked": false,
            },
            {
                "code": 7,
                "codeOrdr": 2,
                "judgCrr1": 150,
                "judgMkr1": "≤",
                "judgCrr2": 100,
                "judgMkr2": ">",
                "judgSymb": "°C",
                "count": 0,
                "isChecked": false,
            },
            {
                "code": 7,
                "codeOrdr": 3,
                "judgCrr1": 200,
                "judgMkr1": "≤",
                "judgCrr2": "150",
                "judgMkr2": ">",
                "judgSymb": "°C",
                "count": 0,
                "isChecked": false,
            },
            {
                "code": 7,
                "codeOrdr": 4,
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": "200",
                "judgMkr2": ">",
                "judgSymb": "°C",
                "count": 0,
                "isChecked": false,
            },
        ],
        InspectionPressureOptions: [
            {
                "code": 8,
                "codeOrdr": 1,
                "judgCrr1": 100,
                "judgMkr1": "≤",
                "judgCrr2": '-∞',
                "judgMkr2": ">",
                "judgSymb": "PSI",
                "count": 0,
                "isChecked": false,
            },
            {
                "code": 8,
                "codeOrdr": 2,
                "judgCrr1": 150,
                "judgMkr1": "≤",
                "judgCrr2": 100,
                "judgMkr2": ">",
                "judgSymb": "PSI",
                "count": 0,
                "isChecked": false,
            },
            {
                "code": 8,
                "codeOrdr": 3,
                "judgCrr1": 200,
                "judgMkr1": "≤",
                "judgCrr2": "150",
                "judgMkr2": ">",
                "judgSymb": "PSI",
                "count": 0,
                "isChecked": false,
            },
            {
                "code": 8,
                "codeOrdr": 4,
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": "200",
                "judgMkr2": ">",
                "judgSymb": "PSI",
                "count": 0,
                "isChecked": false,
            },
        ],
        inspectionPropertiesWithCheck: [
            { name: "3D Model", isChecked: true },
            { name: "Documents", isChecked: false },
            { name: "Asset Class", isChecked: false },
            { name: "Inspection", isChecked: false },
            { name: "VI/NDI Inspection Date", isChecked: true },
            { name: "VI/NDI Next Inspection Date", isChecked: true },
            { name: "Base specification Url", isChecked: true },
            { name: "Rt", isChecked: true },
            { name: "Rl", isChecked: true },
            // { name: "End of Life", isChecked: true },
            { name: "Thickness history Url", isChecked: true },
            { name: "Category", isChecked: false },
            { name: "Cathodic Protection End Date", isChecked: false },
            { name: "Cathodic Protection Start Date", isChecked: false },
            { name: "Cathodic Protection Status", isChecked: false },
            { name: "CL No.", isChecked: false },
            { name: "Code 1", isChecked: false },
            { name: "Code 2", isChecked: false },
            { name: "Code 3", isChecked: false },
            { name: "Corrosion Loop No.1", isChecked: false },
            { name: "Corrosion Loop No.2", isChecked: false },
            { name: "Cr", isChecked: true },
            { name: "Criticality", isChecked: false },
            { name: "Current Risk", isChecked: false },
            { name: "Date of production", isChecked: false },
            { name: "El", isChecked: true },
            { name: "Equipment Start Date", isChecked: false },
            { name: "Equipment End Date", isChecked: false },
            { name: "Func Location", isChecked: false },
            { name: "Failure Date", isChecked: false },
            { name: "Failure Type", isChecked: false },
            { name: "Fluid Classification 1", isChecked: false },
            { name: "Fluid Classification 2", isChecked: false },
            { name: "Flow Class", isChecked: false },
            { name: "Flow name", isChecked: false },
            { name: "Form", isChecked: false },
            { name: "From", isChecked: false },
            { name: "Function", isChecked: false },
            { name: "Future Risk w/o Inspections", isChecked: false },
            { name: "Future Risk w/ Inspections", isChecked: false },
            { name: "General regulations", isChecked: false },
            { name: "Importance", isChecked: false },
            { name: "Inspection Report Created Date", isChecked: false },
            { name: "Inspection Report Issued Date", isChecked: false },
            { name: "Inspection Recommendation Date", isChecked: false },
            { name: "Inspection Results Approval Status", isChecked: false },
            { name: "Inspection Results Excess Corrosion", isChecked: false },
            { name: "Inspection Results Pending Report", isChecked: false },
            { name: "Inspection Iso Number", isChecked: false },
            { name: "Inspection Iso Revision Number", isChecked: false },
            { name: "IOW Excursion of Limits", isChecked: false },
            { name: "Last Inspection Date", isChecked: true },
            { name: "Line No. Code", isChecked: false },
            { name: "Manufacturer", isChecked: false },
            { name: "Measured Thickness", isChecked: false },
            { name: "Min Thickness", isChecked: false },
            { name: "Name", isChecked: true },
            { name: "Next Inspection Date", isChecked: true },
            { name: "Plant", isChecked: false },
            { name: "P&ID Drawing Number", isChecked: false },
            { name: "P&ID Revision Number", isChecked: false },
            { name: "Pressure 1", isChecked: false },
            { name: "Pressure 2", isChecked: false },
            { name: "Pressure 3", isChecked: false },
            { name: "Pressure 4", isChecked: false },
            { name: "Pressure Unit", isChecked: false },
            { name: "Protected/Un-Protected", isChecked: false },
            { name: "Recommendation", isChecked: false },
            { name: "Recommendation Date", isChecked: false },
            { name: "Rl", isChecked: true },
            { name: "Risk Matrix Rating", isChecked: false },
            { name: "Rt", isChecked: true },
            { name: "Severity", isChecked: false },
            { name: "System", isChecked: false },
            { name: "Subsystem", isChecked: false },
            { name: "Tag Description", isChecked: false },
            { name: "Tag No.", isChecked: false },
            { name: "Target DF Date", isChecked: false },
            { name: "Temperature 1", isChecked: false },
            { name: "Temperature 2", isChecked: false },
            { name: "Temperature 3", isChecked: false },
            { name: "Temperature 4", isChecked: false },
            { name: "Temperature Unit", isChecked: false },
            { name: "To", isChecked: false },
            { name: "Type", isChecked: false },
            { name: "Utilization status", isChecked: false },
            { name: "VI/NDI Inspection Date", isChecked: true },
            { name: "VI/NDI Next Inspection Date", isChecked: true },
        ]

    },

    mutations: {
        SET_SHOW_INSPECTION_DASHBOARD(state, value) {
            state.showInspectionDashboard = value;
        },
        SET_INSPECTION_CODES_OPTIONS(state, value) {
            state.inspectionCodesOptions = value;
        },
        SET_TEMP_PRESS_FILTER(state, value) {
            state.tempPressFilter = value;
        },
        SET_INSPECTION_TEMPERATURE_OPTIONS(state, value) {
            state.InspectionTemperatureOptions = value;
        },
        SET_INSPECTION_PRESSURE_OPTIONS(state, value) {
            state.InspectionPressureOptions = value;
        },
        SET_RESET_DASHBOARD_GRID(state, value) {
            state.dispatchResetDashboardGrid = value;
        },
        SET_SHOW_COLUMN_CHOOSER_POPUP(state, value) {
            state.showColumnChooserPopup = value;
        },
        SET_INSPECTION_PROPERTIES_WITH_CHECK(state, value) {
            state.inspectionPropertiesWithCheck = value;
        },
        SET_SHOW_FLOATING_PANEL(state, value) {
            state.showFloatingPanel = value;
        },
        SET_DISPATCH_RESET_DASHBOARD_CHART(state, value) {
            state.dispatchResetDashboardChart = value;
        },
        SET_TEMP_UNIT(state, value) {
            state.tempUnit = value;
        },
        SET_PRESS_UNIT(state, value) {
            state.pressUnit = value;
        },
    },
    getters: {
        GET_SHOW_INSPECTION_DASHBOARD(state) {
            return state.showInspectionDashboard;
        },
        GET_INSPECTION_CODES_OPTIONS(state) {
            return state.inspectionCodesOptions;
        },
        GET_INSPECTION_CODES_OPTIONS_SELECTED(state) {
            if (state.inspectionCodesOptions.length == 0) return [];
            return state.inspectionCodesOptions.filter(o => o.isChecked && o.name !== 'Select All').map(o => o.name);
        },
        GET_INSPECTION_MAIN_SELECTED_FILTER() {
            return store.state.TAGS.inspectionFiltersOptionsWithCheck.find(o => o.isChecked)?.name;
        },
        GET_TEMP_PRESS_FILTER(state) {
            return state.tempPressFilter;
        },
        GET_INSPECTION_TEMP_PRES_SELECTED_FILTER(state) {
            return state.tempPressFilter.find(o => o.isChecked)?.name;
        },
        GET_INSPECTION_TEMPERATURE_OPTIONS(state) {
            return state.InspectionTemperatureOptions;
        },
        GET_INSPECTION_PRESSURE_OPTIONS(state) {
            return state.InspectionPressureOptions;
        },
        GET_INSPECTION_TEMPERATURE_OPTIONS_SELECTED(state) {
            if (state.InspectionTemperatureOptions.length == 0) return [];
            return state.InspectionTemperatureOptions.filter(o => o.isChecked);
        },
        GET_INSPECTION_PRESSURE_OPTIONS_SELECTED(state) {
            if (state.InspectionPressureOptions.length == 0) return [];
            return state.InspectionPressureOptions.filter(o => o.isChecked);
        },
        GET_RESET_DASHBOARD_GRID(state) {
            return state.dispatchResetDashboardGrid;
        },
        GET_SHOW_COLUMN_CHOOSER_POPUP(state) {
            return state.showColumnChooserPopup;
        },
        GET_INSPECTION_PROPERTIES_WITH_CHECK(state) {
            return state.inspectionPropertiesWithCheck;
        },
        GET_SHOW_FLOATING_PANEL(state) {
            return state.showFloatingPanel;
        },
        GET_DISPATCH_RESET_DASHBOARD_CHART(state) {
            return state.dispatchResetDashboardChart;
        },
        GET_TEMP_UNIT(state) {
            return state.tempUnit;
        },
        GET_PRESS_UNIT(state) {
            return state.pressUnit;
        },
    },
    actions: {
        UPDATE_INSPECTION_DASHBOARD_DATA({ dispatch }) {
            dispatch('GET_UNITS_SUMMARY_API');
            dispatch('GET_INSPECTION_EXTRA_FILTER_SUMMARY');
        },
        UPDATE_INSPECTION_DASHBOARD({ dispatch }) {
            dispatch('GET_INSPECTION_EXTRA_FILTER_SUMMARY');
        },
        LOAD_AMIS_TEMP_PRESS_UNITS({ commit }) {
            return new Promise((resolve, reject) => {
                let assetId = store.getters.getAssetId;

                HttpService.get({
                    url: `api/dashboard/${assetId}/getTempPressUnits`,
                    ...FACILITY_REQUEST,
                }).then(({ data }) => {

                    let temp = data[0];
                    if (temp) commit('SET_TEMP_UNIT', temp);

                    let press = data[1];
                    if (press) commit('SET_PRESS_UNIT', press);

                    resolve(data);

                }).catch(error => {
                    debugLog(error)
                    reject(error);
                });

            });
        },
        GET_DASHBOARD_FILTERED_INSPECTION({ dispatch, getters }, { pagingModel, sortModel, assetId, searchText }) {
            let convertInf = (value) => {
                if (value == '-∞') return -10e9;
                if (value == '∞') return 10e9;
                return value;
            }

            if (sortModel?.colId == 'point') sortModel.colId = 'Point_X';

            let propertyFilter = getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX;
            let codes = [2, 3].includes(propertyFilter) ? getters.GET_INSPECTION_CODES_OPTIONS_SELECTED : [];
            let pressureFilters = [2, 3].includes(propertyFilter) && getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'Pressure' ? getters.GET_INSPECTION_PRESSURE_OPTIONS_SELECTED : [];
            let temperatureFilters = [2, 3].includes(propertyFilter) && getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'Temperature' ? getters.GET_INSPECTION_TEMPERATURE_OPTIONS_SELECTED : [];
            let filters = getters.GET_SELECTED_COLORS_OPTIONS;

            return new Promise((resolve, reject) => {
                return HttpService.post({
                    url: `api/dashboard/getDashboardFilteredInspection`,
                    data: {
                        pagingModel,
                        sortModel,
                        search: searchText,
                        assetId: assetId,
                        propertyFilter: propertyFilter,
                        allowNull: getters.GET_IS_PROPERTY_ALLOW_NULL,
                        units: getters['GET_UNITS'].filter(o => o.isChecked).map(o => o.name),
                        codes: codes,
                        ColorsFilters: filters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                minOps: o.judgMkr2,
                                max: convertInf(o.judgCrr1),
                                maxOps: o.judgMkr1,
                            }
                        }),
                        temperatureFilters: temperatureFilters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                max: convertInf(o.judgCrr1),
                            }
                        }),
                        pressureFilters: pressureFilters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                max: convertInf(o.judgCrr1),
                            }
                        }),
                    },
                }).then(response => {
                    let result = response.data.map(o => Object.assign(new ForgeInspection(), o));

                    result.forEach(o => {
                        o.isFetched = true;
                        o.parseContent()
                    });

                    resolve(result);
                }).catch(error => {
                    debugLog(error)
                    reject(error);
                })
            });
        },
        GET_UNITS_SUMMARY_API({ commit, getters }) {
            let convertInf = (value) => {
                if (value == '-∞') return -10e9;
                if (value == '∞') return 10e9;
                return value;
            }

            let propertyFilter = getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX;
            let filters = getters.GET_AVAILABLE_COLORS_OPTIONS.filter(item => item.title !== 'N/A');
            let units = getters['GET_UNITS'];
            let codes = [2, 3].includes(propertyFilter) ? getters.GET_INSPECTION_CODES_OPTIONS_SELECTED : [];
            let pressureFilters = [2, 3].includes(propertyFilter) && getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'Pressure' ? getters.GET_INSPECTION_PRESSURE_OPTIONS_SELECTED : [];
            let temperatureFilters = [2, 3].includes(propertyFilter) && getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'Temperature' ? getters.GET_INSPECTION_TEMPERATURE_OPTIONS_SELECTED : [];

            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: `api/dashboard/getDashboardUnitsSummary`,
                    data: {
                        assetId: store.getters.getAssetId,
                        propertyFilter: propertyFilter,
                        units: units.map(o => o.name),
                        codes: codes,
                        filters: filters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                minOps: o.judgMkr2,
                                max: convertInf(o.judgCrr1),
                                maxOps: o.judgMkr1,
                            }
                        }),
                        temperatureFilters: temperatureFilters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                max: convertInf(o.judgCrr1),
                            }
                        }),
                        pressureFilters: pressureFilters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                max: convertInf(o.judgCrr1),
                            }
                        }),
                    },
                }).then(response => {
                    units.forEach((o, i) => {
                        o.counts = response.data.length > 0 ? response.data[i].counts : 0;
                    });

                    commit('SET_DISPATCH_RESET_DASHBOARD_CHART', new Date());

                    resolve(response.data);
                }).catch(error => {
                    debugLog(error)
                    reject(error);
                });
            })
        },
        GET_INSPECTION_EXTRA_FILTER_SUMMARY({ dispatch, getters }) {
            if (getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'None') return;

            let isTemperatureFilterSelected = getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'Temperature';
            let dispatchName = isTemperatureFilterSelected ? 'GET_INSPECTION_TEMPERATURE_SUMMARY_API' : 'GET_INSPECTION_PRESSURE_SUMMARY_API';

            return dispatch(dispatchName);
        },
        GET_AVAILABLE_CODES_API({ commit, getters }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: `api/dashboard/getAvailableCodes`,
                    data: {
                        assetId: store.getters.getAssetId,
                        propertyFilter: getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX,
                        units: getters['GET_UNITS'].filter(o => o.isChecked).map(o => o.name)
                    },
                }).then(response => {
                    // response.data.splice(0, 0, 'Select All');

                    let options = response.data.map(o => {
                        return {
                            id: o,
                            name: o,
                            isChecked: true,
                        }
                    });
                    commit('SET_INSPECTION_CODES_OPTIONS', options);
                    resolve(response.data);
                }).catch(error => {
                    debugLog(error)
                    reject(error);
                });
            })
        },
        GET_INSPECTION_TEMPERATURE_SUMMARY_API({ getters }) {
            let assetId = store.getters.getAssetId;
            let propertyFilter = getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX;
            let units = getters['GET_UNITS'].filter(o => o.isChecked).map(o => o.name);
            let codes = getters.GET_INSPECTION_CODES_OPTIONS_SELECTED;

            let convertInf = (value) => {
                if (value == '-∞') return -10e9;
                if (value == '∞') return 10e9;
                return value;
            }

            let filters = getters.GET_INSPECTION_TEMPERATURE_OPTIONS.map(o => {
                return {
                    min: convertInf(o.judgCrr2),
                    minOps: o.judgMkr2,
                    max: convertInf(o.judgCrr1),
                    maxOps: o.judgMkr1,
                }
            });

            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: `api/dashboard/getInspectionTemperatureSummary`,
                    data: {
                        assetId: assetId,
                        propertyFilter: propertyFilter,
                        units: units,
                        filters: filters,
                        codes: codes,
                    },
                }).then(response => {
                    getters.GET_INSPECTION_TEMPERATURE_OPTIONS.forEach((o, i) => {
                        o.count = response.data[i];
                    });
                    resolve(response.data);
                }).catch(error => {
                    debugLog(error)
                    reject(error);
                });
            })
        },
        GET_INSPECTION_PRESSURE_SUMMARY_API({ getters }) {
            let assetId = store.getters.getAssetId;
            let propertyFilter = getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX;
            let units = getters['GET_UNITS'].filter(o => o.isChecked).map(o => o.name);
            let codes = getters.GET_INSPECTION_CODES_OPTIONS_SELECTED;

            let convertInf = (value) => {
                if (value == '-∞') return -10e9;
                if (value == '∞') return 10e9;
                return value;
            }

            let filters = getters.GET_INSPECTION_PRESSURE_OPTIONS.map(o => {
                return {
                    min: convertInf(o.judgCrr2),
                    minOps: o.judgMkr2,
                    max: convertInf(o.judgCrr1),
                    maxOps: o.judgMkr1,
                }
            });

            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: `api/dashboard/getInspectionPressureSummary`,
                    data: {
                        assetId: assetId,
                        propertyFilter: propertyFilter,
                        units: units,
                        filters: filters,
                        codes: codes,
                    },
                }).then(response => {
                    getters.GET_INSPECTION_PRESSURE_OPTIONS.forEach((o, i) => {
                        o.count = response.data[i];
                    });
                    resolve(response.data);
                }).catch(error => {
                    debugLog(error)
                    reject(error);
                });
            })
        },
    },

}